import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import MarketingApp from "./marketing/MarketingApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MarketingApp />
  </React.StrictMode>,
);
